import { useAtomValue } from 'jotai';
import { getQuoteRejectReasonsAtom } from '../../../store/global/atoms';

export const useGetQuoteRejectReasons = () => {
  const getQuoteRejectReasons = useAtomValue(getQuoteRejectReasonsAtom);

  return {
    getQuoteRejectReasons: getQuoteRejectReasons.mutate,
    isLoading: getQuoteRejectReasons.isPending,
    error: getQuoteRejectReasons.error,
  };
};
